<template>
  <li
    :data-type="node.type.name"
    :data-done="node.attrs.done"
    data-drag-handle
  >
    <span
      class="todo-checkbox"
      contenteditable="false"
      @click="onChange"
    >
      <m-icon
        v-if="node.attrs.done"
        type="check"
        color="white"
        size="14"
      />
    </span>
  </li>
</template>

<script>
export default {
  name: 'ToDoItemComponent',
  props: {
    node: {
      type: Object,
      required: true,
    },
    updateAttrs: {
      type: Function,
      required: true,
    },
    getPos: {
      type: Function,
      required: true,
    },
    // the editor renders the item's paragraphs into this element and owns it from before
    // this component mounts, so it is adopted rather than rendered by the template
    contentDOM: {
      type: HTMLElement,
      required: true,
    },
  },
  methods: {
    onChange() {
      this.updateAttrs({ done: !this.node.attrs.done });
    },
  },
  mounted() {
    this.contentDOM.classList.add('todo-content');
    // moving the element collapses a selection inside it, and the editor has just put the
    // cursor there when this item came out of splitting another
    const selection = window.getSelection();
    const { anchorNode, anchorOffset, focusNode, focusOffset } = selection;
    this.$el.appendChild(this.contentDOM);
    if (this.contentDOM.contains(anchorNode)) {
      selection.setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset);
    }
  },
};
</script>

<style lang="scss" type="text/scss">
  li[data-type="todo_item"] {
    display: flex;
    flex-direction: row;
    padding-left: .6rem;
  }

  .todo-checkbox {
    box-sizing: border-box;
    width: 1.6rem;
    height: 1.6rem;

    // centred on the first line of the item's own paragraph, which is as tall as the editor's
    // font makes it: the paragraph's .3rem of padding, plus half of what the line has over the
    // box. A fixed offset only ever lands on one font size
    margin-top: calc(.75em - .5rem);
    margin-right: 1rem;
    cursor: pointer;
    background-color: transparent;
    border: 1.5px solid map_get($grey, 'darken-3');
    border-radius: 0;
    transition: .4s background;
  }

  .todo-content {
    flex: 1;
  }

  li[data-done="true"] {
    > .todo-content {
      > p {
        color: $font-color-tertiary;
        text-decoration: line-through;
      }
    }

    > .todo-checkbox {
      background-color: $primary-color;
      border-color: $primary-color;
    }
  }

  li[data-done="false"] {
    text-decoration: none;
  }

  // a read-only editor drops the transaction the click would dispatch, so the box must not
  // offer itself as something to press
  .ProseMirror[contenteditable="false"] .todo-checkbox {
    cursor: default;
  }
</style>
